
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsOkDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 92,
  height: 92,
  viewBox: "0 0 92 92"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M46 0a3 3 0 1 1 0 6C24.13 6 6.359 23.552 6.005 45.339L6 45.996C6.029 68.098 23.954 86 46.065 86c3.083.008 6.155-.36 9.18-1.106C73.268 80.656 86.005 64.572 86 46.057a3 3 0 1 1 6-.001c.005 21.3-14.647 39.803-35.35 44.672A43.826 43.826 0 0 1 46.056 92C20.644 92 .033 71.417 0 46.004v-.008l.006-.757C.412 20.185 20.85 0 46 0zm35.12 17.877a3 3 0 0 1 .138 4.098l-.135.144-37.933 38a2.999 2.999 0 0 1-4.102.136l-.144-.136-12.067-12.088a3 3 0 0 1 4.102-4.373l.144.134 9.943 9.961 35.81-35.872a3 3 0 0 1 4.243-.004z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"92\" height=\"92\" viewBox=\"0 0 92 92\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\">\r\n            <path d=\"M46 0c1.657 0 3 1.343 3 3s-1.343 3-3 3C24.13 6 6.359 23.552 6.005 45.339L6 45.996C6.029 68.098 23.954 86 46.065 86c3.083.008 6.155-.36 9.18-1.106C73.268 80.656 86.005 64.572 86 46.057c0-1.657 1.342-3 3-3 1.656-.001 3 1.342 3 2.999.005 21.3-14.647 39.803-35.35 44.672-3.469.854-7.03 1.282-10.594 1.272C20.644 92 .033 71.417 0 46.004v-.008l.006-.757C.412 20.185 20.85 0 46 0zm35.12 17.877c1.125 1.124 1.172 2.919.138 4.098l-.135.144-37.933 38c-1.125 1.128-2.923 1.173-4.102.136l-.144-.136-12.067-12.088c-1.17-1.173-1.17-3.072.004-4.243 1.125-1.123 2.92-1.167 4.098-.13l.144.134 9.943 9.961 35.81-35.872c1.171-1.173 3.07-1.175 4.243-.004z\" transform=\"translate(-142 -257) translate(142 257)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-ok-done.415c0a20c19670e37d84fa2a4453527f.svg"),
        {
          React: SvgIconsOkDone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      